(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-marquee"]) return;
  try {
    
  (() => {
    let current = null;
    function initRibbon() {
      const ribbon = document.querySelector('[data-epic-ribbon]');
      if (!ribbon || current?.ribbon === ribbon) return;
      current?.destroy();
      const luxe = ribbon.querySelector('[data-ribbon-luxe]');
      const slot = ribbon.querySelector('[data-ribbon-native]');
      const viewport = ribbon.querySelector('[data-ribbon-viewport]');
      const track = ribbon.querySelector('[data-ribbon-track]');
      const group = ribbon.querySelector('[data-ribbon-group]');
      const pause = ribbon.querySelector('[data-ribbon-pause]');
      const clone = group.cloneNode(true);
      clone.removeAttribute('data-ribbon-group');
      clone.setAttribute('data-ribbon-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      track.append(clone);
      pause.hidden = false;
      ribbon.dataset.running = 'true';
      const sizeTrack = () => {
        if (!viewport.clientWidth) return;
        ribbon.style.setProperty('--epic-ribbon-width', `${viewport.clientWidth}px`);
        ribbon.style.setProperty('--epic-ribbon-duration', `${Math.max(20, group.getBoundingClientRect().width / 40)}s`);
      };
      const resize = new ResizeObserver(sizeTrack);
      resize.observe(viewport);
      sizeTrack();
      pause.addEventListener('click', () => {
        const paused = ribbon.dataset.paused !== 'true';
        ribbon.dataset.paused = String(paused);
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.querySelector('[data-ribbon-pause-icon]').hidden = paused;
        pause.querySelector('[data-ribbon-play-icon]').hidden = !paused;
      });
      let native = null, frame = 0;
      const rendered = element => {
        if (!element?.isConnected || !element.textContent.trim()) return false;
        for (let parent = element; parent && parent !== slot; parent = parent.parentElement) {
          const style = getComputedStyle(parent);
          if (parent.hidden || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
        }
        return element.getClientRects().length > 0;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(syncNative); };
      const nativeObserver = new MutationObserver(schedule);
      function syncNative() {
        frame = 0;
        if (document.documentElement.classList.contains('epic-root-locked')) return;
        const candidate = document.getElementById('limoniapps-discountninja-stickybar-wrapper');
        if (candidate !== native) {
          nativeObserver.disconnect();
          native = candidate;
          if (native) nativeObserver.observe(native, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
        }
        const active = Boolean(native && [...native.querySelectorAll('.limoniapps-message-body')].some(rendered));
        if (active && native.parentElement !== slot) slot.append(native);
        slot.classList.toggle('is-active', active);
        luxe.hidden = active;
        if (active) document.documentElement.setAttribute('data-epic-ribbon-native', '');
        else document.documentElement.removeAttribute('data-epic-ribbon-native');
      }
      const discovery = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.id === 'limoniapps-discountninja-stickybar-wrapper' || node.querySelector?.('#limoniapps-discountninja-stickybar-wrapper'))))) schedule();
      });
      discovery.observe(document.body, {childList:true,subtree:true});
      const rootObserver = new MutationObserver(schedule);
      rootObserver.observe(document.documentElement, {attributes:true,attributeFilter:['class']});
      const events = ['la:dn:api:ready','la:dn:promotions:loaded','la:dn:cart:updated'];
      events.forEach(name => document.addEventListener(name, schedule));
      window.addEventListener('pageshow',schedule);
      window.addEventListener('resize', schedule);
      syncNative();
      current = {ribbon,destroy() {
        cancelAnimationFrame(frame);
        resize.disconnect();nativeObserver.disconnect();discovery.disconnect();rootObserver.disconnect();
        events.forEach(name => document.removeEventListener(name,schedule));
        window.removeEventListener('pageshow',schedule);
        window.removeEventListener('resize',schedule);
        if (native && slot.contains(native)) document.body.append(native);
        document.documentElement.removeAttribute('data-epic-ribbon-native');
      }};
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initRibbon,{once:true});
    else initRibbon();
    document.addEventListener('shopify:section:load',initRibbon);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation"]) return;
  try {
    
  const activeSubMenuBtnStyle = '!bg-black text-white !border-black';
  const filterStyling = '!bg-black text-white !border-black';

  const queryParams = new URLSearchParams(window.location.search);
  const URLParamMenu = queryParams.get('menu');
  const MainMenuItems = document.querySelectorAll('.main-menu-item');
  const matchedMenuItem = Array.from(MainMenuItems).find((item) => item.textContent.includes(URLParamMenu));

  let closeMenuTimeout = null;
  var letterFilter = null;
  var brandTypeFilter = null;
  let menuJustOpened = false; // Flag to prevent immediate close on iOS after click
  let isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Function to check if we should use mobile menu behavior (touch device OR small viewport)
  function shouldUseMobileMenuBehavior() {
    const isSmallViewport = $(window).width() <= 768; // Match your existing mobile breakpoint
    return isTouchDevice || isSmallViewport;
  }

  function updateNavIndicators(swiperInstance, leftSelector, rightSelector) {
    const $swiperEl = $(swiperInstance.el);
    $swiperEl.find(leftSelector).css('opacity', swiperInstance.isBeginning ? '0' : '1');
    $swiperEl.find(rightSelector).css('opacity', swiperInstance.isEnd ? '0' : '1');
  }

  function closeMenu(skipFlagReset) {
    $('.submenu').hide();
    $('.main-menu-item, .brand-menu-item').removeClass('active-menu-item').css('opacity', '1');
    $('body').css('overflow', '');
    // Only reset flag if we're not about to open a new menu
    if (!skipFlagReset) {
      menuJustOpened = false;
    }
  }

  function delayedCloseMenu() {
    // Don't close menu on touch devices or small viewports (menu should only close via explicit close button)
    // This prevents iOS Safari/Edge from closing menu after tap due to simulated mouseleave events
    if (shouldUseMobileMenuBehavior()) {
      return;
    }
    // Don't close menu if it was just opened via click (additional safeguard)
    if (menuJustOpened) {
      return;
    }
    // Extra safety: check if any submenu is currently visible
    const visibleSubmenus = $('.submenu:visible').length;
    if (visibleSubmenus > 0 && shouldUseMobileMenuBehavior()) {
      return;
    }
    closeMenuTimeout = setTimeout(closeMenu, 500);
  }

  function markup_brand(collection) {
    let mensLabel = '';
    if (collection.brandTypes.includes('Mens')) {
      mensLabel =
        '<span class="block absolute top-1.5 right-1.5 leading-none text-xs font-medium rounded-full bg-allure-100 text-black px-2 py-1">Mens</span>';
    }
    // prettier-ignore
    return `
        <div data-name="${collection.title.toLowerCase()}">
          <a class="collection-item relative grid place-items-center p-4 h-20 bg-white border border-allure-200 rounded-lg transition-colors hover:border-allure lg:h-24 lg:p-5" aria-label="Visit ${collection.title} Collection Page" href="${collection.url}">
            ${mensLabel}
            <img class="max-h-8 lg:max-h-10" loading="lazy" src="${collection.logoUrl}" alt="${collection.title} logo">
          </a>
        </div>
        `;
  }

  function generateSlides(collections) {
    $('.menu-brand-wrapper').empty();
    collections.forEach(function (collection) {
      var slide = markup_brand(collection);
      $('.menu-brand-wrapper').append(slide);
    });
  }

  function generateFilteredBrandSlides(filterFunction, targetElement) {
    if (typeof brandCollections === 'undefined' || !Array.isArray(brandCollections)) {
      console.warn('brandCollections is not defined or is not an array');
      return;
    }
    $(targetElement).empty();
    var filteredCollections = brandCollections.filter(filterFunction);
    filteredCollections.forEach(function (collection) {
      var slide = markup_brand(collection);
      $(targetElement).append(slide);
    });
  }

  function initialFilter(collections) {
    return collections.filter(function (collection) {
      return collection.excludeFromAll !== 'true';
    });
  }

  function filterSlides() {
    if (typeof brandCollections === 'undefined' || !Array.isArray(brandCollections)) {
      console.warn('brandCollections is not defined or is not an array');
      return;
    }
    var filteredCollections = brandCollections.filter(function (collection) {
      var letterMatch = true;
      var brandTypeMatch = true;

      if (brandTypeFilter !== null) {
        if (brandTypeFilter === 'all') {
          brandTypeMatch = collection.excludeFromAll !== 'true';
        } else if (brandTypeFilter === 'Ladies Haircare') {
          brandTypeMatch = collection.brandTypes.includes('Haircare') && !collection.brandTypes.includes('Mens');
        } else if (brandTypeFilter === 'Mens Haircare') {
          brandTypeMatch = collection.brandTypes.includes('Haircare') && collection.brandTypes.includes('Mens');
        } else if (
          brandTypeFilter === 'Electrical' ||
          brandTypeFilter === 'Beauty' ||
          brandTypeFilter === 'Australian'
        ) {
          brandTypeMatch = collection.brandTypes.includes(brandTypeFilter);
        } else {
          brandTypeMatch = true;
        }
      }

      if (letterFilter !== null) {
        var firstLetter = collection.title.charAt(0).toUpperCase();
        var startLetter = letterFilter.charAt(0);
        var endLetter = letterFilter.charAt(letterFilter.length - 1);
        letterMatch = firstLetter >= startLetter && firstLetter <= endLetter;
      }

      return letterMatch && brandTypeMatch;
    });
    generateSlides(filteredCollections);
  }

  function filterByLetterGroup(letterGroup) {
    letterFilter = letterGroup;
    $('.letter-group').removeClass(filterStyling);
    $('.letter-group[data-group="' + letterGroup + '"]').addClass(filterStyling);
    filterSlides();
  }

  function filterByBrandType(brandType) {
    brandTypeFilter = brandType;
    //$('.brand-type-filter').removeClass('border-b-2 border-black');
    //$('.brand-type-filter[data-brand-type="' + brandType + '"]').addClass('border-b-2 border-black');

    filterSlides();
  }

  function addMenuTabsInstance() {
    const menuTabs = document.querySelectorAll('.menu-tabs');
    menuTabs.forEach((tab, index) => {
      tab.setAttribute('data-menu-tabs-instance', index);
    });
  }

  $(document).ready(function () {
    const navSlider = new Swiper('.navigation', {
      slidesPerView: 'auto',
      freeMode: true,
      autoHeight: true,
      touchEventsTarget: 'container',
      touchReleaseOnEdges: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.navigation .nav_right_indicator',
        disabledClass: 'opacity-0',
      },
    });

    const navMenuTabs = new Swiper('.menu-tabs', {
      init: false,
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: true,
      touchEventsTarget: 'container',
      touchReleaseOnEdges: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.menu-tabs .nav_right_indicator',
        disabledClass: 'opacity-0',
      },
    });

    const navSubButtons = new Swiper('.submenu-buttons', {
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: true,
      autoHeight: true,
      touchEventsTarget: 'container',
      touchReleaseOnEdges: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.submenu-buttons .nav_right_indicator',
        disabledClass: 'opacity-0',
      },
    });

    // Handle menu open/close behavior differently for touch/small viewport vs desktop
    if (shouldUseMobileMenuBehavior()) {
      // On touch devices or small viewports: NO mouseleave handlers at all for menu items
      // Menu only closes via explicit close button
      // This prevents iOS Safari/Edge simulated mouseleave events from closing menu
      // Only attach mouseover to cancel any pending timeouts (safety measure)
      $('.submenu').on('mouseover', function () {
        clearTimeout(closeMenuTimeout);
      });
    } else {
      // Desktop: normal hover behavior with mouseleave
      $('.main-menu-item, .brand-menu-item, .submenu')
        .on('mouseover', function () {
          clearTimeout(closeMenuTimeout);
        })
        .on('mouseleave', function () {
          delayedCloseMenu();
        });
    }

    // Click/touch handler for menu items (works on both touch and desktop)
    $('.main-menu-item, .brand-menu-item').on('click', function (e) {
      // On touch devices or small viewports, set flag IMMEDIATELY to block any pending mouseleave events
      if (shouldUseMobileMenuBehavior()) {
        menuJustOpened = true;
        // Keep flag set for extended period on touch devices/small viewports
        clearTimeout(window.menuJustOpenedTimeout);
        window.menuJustOpenedTimeout = setTimeout(function () {
          menuJustOpened = false;
        }, 3000); // 3 seconds to ensure menu stays open
      }

      // Clear any pending close timeout immediately
      clearTimeout(closeMenuTimeout);

      const submenuId = $(this).data('submenu-id');
      const selectedSubmenu = $('div.submenu[data-submenu-id="' + submenuId + '"]');
      const menuTabsInstance = selectedSubmenu.find('.menu-tabs').data('menu-tabs-instance');
      const OtherMenus = $('.other-menus');

      if ($(this).hasClass('active-menu-item')) {
        closeMenu();
        if (shouldUseMobileMenuBehavior()) {
          menuJustOpened = false;
        }
        return;
      }

      // Close menu but don't reset flag yet (we're about to open a new one)
      closeMenu(true);

      if ($(window).width() <= 768) {
        var position = $('#shopify-section-header-navigation').offset().top;
        $('html, body').animate({
          scrollTop: position,
        });
      }

      if (typeof navMenuTabs[menuTabsInstance] !== 'undefined') {
        navMenuTabs[menuTabsInstance].init();
      }

      $(this).addClass('active-menu-item').css('opacity', '1');
      selectedSubmenu.css('display', 'flex');
      OtherMenus.css('display', 'flex');

      var firstMenuLink = selectedSubmenu.find('.menu-link').first();
      if (firstMenuLink.length > 0) {
        firstMenuLink.addClass('border-b-2 border-black');
        firstMenuLink.trigger('click');
      } else {
        selectedSubmenu.find('.top-level-menu').show();
      }

      if ($(window).width() <= 768) {
        $('body').css('overflow', 'hidden');
      }
    });

    $('.menu-link').click(function () {
      const menuLinkId = $(this).data('menu-link-id');
      const topLevelMenu = $('[data-top-level-menu-id="' + menuLinkId + '"]');
      const IsBrandMenu = $(this).hasClass('brand-link');
      const selectedSubmenu = $('div.submenu[data-submenu-id="' + menuLinkId + '"]');
      const OtherMenus = $('.other-menus');

      $('.top-level-menu').hide();
      OtherMenus.css('display', 'none');

      $('.sub-menu-button').removeClass(activeSubMenuBtnStyle);
      $('.menu-link').removeClass('border-b-2 border-black');

      if (!IsBrandMenu) {
        OtherMenus.css('display', 'flex');
      }

      topLevelMenu.show();

      var firstSubMenuButton = topLevelMenu.find('.sub-menu-button').first();
      firstSubMenuButton.addClass(activeSubMenuBtnStyle);
      firstSubMenuButton.trigger('click');

      $(this).addClass('border-b-2 border-black');
    });

    $('.sub-menu-button').click(function () {
      var topLevelMenu = $(this).closest('.top-level-menu');
      topLevelMenu.find('.sub-sub-menu').hide();
      $('.sub-menu-button').removeClass(activeSubMenuBtnStyle);

      var subMenuId = $(this).data('sub-menu-id');
      topLevelMenu.find('[data-sub-sub-menu-id="' + subMenuId + '"]').show();

      $(this).addClass(activeSubMenuBtnStyle);
    });

    $('.close-menu').on('click', function () {
      closeMenu();
    });

    $('.letter-group').click(function () {
      var group = $(this).data('group');

      if (letterFilter === group) {
        letterFilter = null;
        $(this).removeClass(filterStyling);
        filterSlides();
      } else {
        filterByLetterGroup(group);
      }
    });

    $('.brand-type-filter').click(function () {
      letterFilter = null;
      $('.letter-group').removeClass(filterStyling);
      var brandType = $(this).data('brand-type');
      if (brandTypeFilter === brandType) {
        brandTypeFilter = null;
        $(this).removeClass('border-b-2 border-black');
        $('.brand-type-filter[data-brand-type="all"]').addClass('border-b-2 border-black');
        filterSlides();
      } else {
        filterByBrandType(brandType);
      }
    });

    $('.previousPage').click(function () {
      window.history.back();
    });

    if (typeof brandCollections !== 'undefined' && Array.isArray(brandCollections)) {
      generateFilteredBrandSlides(function (collection) {
        return collection.brandTypes.includes('Beauty');
      }, '.beauty-brand-wrapper');
      generateFilteredBrandSlides(function (collection) {
        return collection.brandTypes.includes('Mens');
      }, '.men-brand-wrapper');
      generateFilteredBrandSlides(function (collection) {
        return collection.brandTypes.includes('Haircare');
      }, '.haircare-brand-wrapper');
      generateFilteredBrandSlides(function (collection) {
        return collection.brandTypes.includes('Electrical') || collection.brandTypes.includes('Tools');
      }, '.toolsAccessories-brand-wrapper');
    }

    addMenuTabsInstance();
    if (typeof brandCollections !== 'undefined' && Array.isArray(brandCollections)) {
      generateSlides(initialFilter(brandCollections));
    } else {
      console.warn('brandCollections is not defined or is not an array - skipping brand slide generation');
    }

    if (URLParamMenu && matchedMenuItem) {
      console.log('matchedMenuItem', matchedMenuItem);
      matchedMenuItem.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-shopby"]) return;
  try {
    
  const homeShopBy = new Swiper('.shopBy', {
    slidesPerView: 'auto',
    autoHeight: true,
    freeMode: {
      enabled: true,
      momentumRatio: 0.5,
    },
    spaceBetween: 12,
    grabCursor: true,
    touchEventsTarget: 'container',
    watchOverflow: true,
    navigation: {
      nextEl: '.shopBy-nav_right_indicator',
    },
    on: {
      init: function () {
        if (this.isEnd) {
          $('.shopBy-nav_right_indicator').css('opacity', '0');
        } else {
          $('.shopBy-nav_right_indicator').css('opacity', '1');
        }
      },
      slideChange: function () {
        if (this.isEnd) {
          $('.shopBy-nav_right_indicator').css('opacity', '0');
        } else {
          $('.shopBy-nav_right_indicator').css('opacity', '1');
        }
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
